import { graphql } from '@/graphql-setup'

export const LEARNING_FOLDERS_QUERY = graphql(`
  query LearningFolders {
    learningFolders {
      module
      total
      completed
      demos {
        id
        title
        description
        demoId
        aspectRatioPercent
        chromeHeightPx
        publishedAt
        progress {
          id
          status
          viewCount
          watchedSeconds
          completedAt
        }
      }
    }
  }
`)
